module.exports = __webpack_public_path__ + "img/retro1.b0b09d00.jpg";